import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

// Custom elements (ai-* prefix)
import "./components/ai-smooth-scroll.js"
import "./components/ai-contact-form.js"

console.info("Bridgetown is loaded!")
